import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\GetDepositAmountController::__invoke
* @see app/Http/Controllers/GetDepositAmountController.php
* @route '/api/invoicing/{invoice}/get-deposit-amount'
*/
const GetDepositAmountController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDepositAmountController.url(args, options),
    method: 'get',
})

GetDepositAmountController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/get-deposit-amount',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GetDepositAmountController::__invoke
* @see app/Http/Controllers/GetDepositAmountController.php
* @route '/api/invoicing/{invoice}/get-deposit-amount'
*/
GetDepositAmountController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetDepositAmountController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\GetDepositAmountController::__invoke
* @see app/Http/Controllers/GetDepositAmountController.php
* @route '/api/invoicing/{invoice}/get-deposit-amount'
*/
GetDepositAmountController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDepositAmountController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\GetDepositAmountController::__invoke
* @see app/Http/Controllers/GetDepositAmountController.php
* @route '/api/invoicing/{invoice}/get-deposit-amount'
*/
GetDepositAmountController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDepositAmountController.url(args, options),
    method: 'head',
})

export default GetDepositAmountController